import { controls, grouped } from "../controls";
const find_matching_records = {
    label: "Find Matching Records",
    pageLabel: "Find Matching Records", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: true } },
    pageType: "history",
    //bulk:{columns:["village_id","taluka_id","suggestion_found","matches_found"] },
    formTabs:
    {
        allTabs: [
            { label: "General", uid: "general" },
            //{label:"Bulk",uid:"bulk"}
        ]
    },
    filter: [
    ]
    , form: [
        ...controls.displayText({ tab: "general", label: "Village", star: false }),
        ...controls.autoComplete({ tab: "general", name: "village_code", width: "col-sm-2", controlType: "Village" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Taluka", star: false }),
        ...controls.autoComplete({ tab: "general", name: "taluka_code", width: "col-sm-2", controlType: "Taluka" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Suggestion Found", star: false }),
        ...controls.numberOnly({ tab: "general", placeHolder: "", name: "suggestion_found", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Matches Found", star: false }),
        ...controls.numberOnly({ tab: "general", placeHolder: "", name: "matches_found", maxlength: 200, isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
    ]
    , history: {
        perPage: 10,
        reportHeader: "Find Matching Records",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "Village", accessor: "FindMatchingRecords-village-village_display", },
            { Header: "Taluka", accessor: "FindMatchingRecords-taluka-taluka_display", },
            { Header: "Total Records", accessor: "total_records", },
            { Header: "Suggestion Found", accessor: "suggestion_found", },
            { Header: "Matches Found", accessor: "matches_found", },
        ]
    }
};
export default find_matching_records;